import { FuseNavigation } from '@fuse/types';
import { SessionItems } from 'app/enums/constants.enum';
import { PermissionType } from 'app/enums/permission.enum';
import { AppRoutePaths } from 'app/enums/routes.enum';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';

export const navigation: FuseNavigation[] = [
    {
        id: 'management',
        title: 'Management',
        translate: 'NAV.MANAGEMENT.TITLE',
        icon: 'admin_panel_settings',
        type: 'collapsable',
        children: [
            {
                id: 'tenants_id',
                title: 'tenants_title',
                translate: 'NAV.TENANTS',
                type: 'item',
                icon: 'assignment_ind',
                url: AppRoutePaths.TENANTS_ALL,
                permission: PermissionType.TenantList.toString()
            },
            {
                id: 'approvals:id',
                title: 'Approvals',
                translate: 'NAV.APPROVALS',
                type: 'item',
                icon: 'assignment_ind',
                url: AppRoutePaths.TENANT_APPROVALS_ALL,
                permission: PermissionType.TenantList.toString()
            },
            {
                id: 'management',
                title: 'Management',
                translate: 'NAV.SECURITY.TITLE',
                icon: 'admin_panel_settings',
                type: 'collapsable',
                children: [
                    {
                        id: PermissionType.UserList.toString(),
                        title: 'SecurityUsers',
                        translate: 'NAV.SECURITY.USERS',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.SECURITY_USERS_ALL,
                        permission: PermissionType.UserList.toString()
                    },
                    {
                        id: PermissionType.UserGroupList.toString(),
                        title: 'SecurityUsersGroups',
                        translate: 'NAV.SECURITY.USER_GROUPS',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.SECURITY_USERS_GROUPS_ALL,
                        permission: PermissionType.UserGroupList.toString()
                    },
                    {
                        id: PermissionType.RoleList.toString(),
                        title: 'SecurityRoles',
                        translate: 'NAV.SECURITY.ROLES',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.SECURITY_ROLES_ALL,
                        permission: PermissionType.RoleList.toString()
                    },
                    {
                        id: PermissionType.AuditList.toString(),
                        title: 'SecurityAudit',
                        translate: 'NAV.SECURITY.AUDIT',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.SECURITY_AUDIT_ALL,
                        permission: PermissionType.AuditList.toString()
                    }                  
                ]
            },

            {
                id: 'control_master',
                title: 'control_master_title',
                translate: 'NAV.CONTROL',
                icon: 'assignment_ind',
                type: 'collapsable',
                children: [
                    {
                        id: 'AssociatedProcesses_id',
                        title: 'AssociatedProcesses_title',
                        translate: 'NAV.ASSOCIATEDPROCESSES',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.ASSOCIATEDPROCESSES_ALL,
                        permission: PermissionType.AssociatedProcessesList.toString()
                    },
                    {
                        id: 'Responsible_id',
                        title: 'Responsible_title',
                        translate: 'NAV.RESPONSIBLE',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.RESPONSIBLE_ALL,
                        permission: PermissionType.ResponsibleList.toString()
                    },
                    {
                        id: 'Risk_id',
                        title: 'Risk_title',
                        translate: 'NAV.RISK',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.RISK_ALL,
                        permission: PermissionType.RiskList.toString()
                    },
                    {
                        id: 'ControlType_id',
                        title: 'ControlType_title',
                        translate: 'NAV.CONTROLTYPE',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.CONTROLTYPE_ALL,
                        permission: PermissionType.ControlTypeList.toString()
                    },
                    {
                        id: 'Periodicity_id',
                        title: 'Periodicity_title',
                        translate: 'NAV.PERIODICITY',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.PERIODICITY_ALL,
                        permission: PermissionType.PeriodicityList.toString()
                    }
                ]
            },

            {
                id: 'complaints',
                title: 'Complaints',
                translate: 'NAV.COMPLAINTS.TITLE',
                icon: 'admin_panel_settings',
                type: 'collapsable',
                children: [
                    {
                        id: PermissionType.FAQList.toString(),
                        title: 'Faqs',
                        translate: 'NAV.COMPLAINTS.FAQS',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_FAQS_ALL,
                        permission: PermissionType.FAQList.toString()
                    },
                    {
                        id: PermissionType.ContentList.toString(),
                        title: 'Content-Resources',
                        translate: 'NAV.COMPLAINTS.CONTENT_RESOURCES',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_CONTENT_RESOURCES_ALL,
                        permission: PermissionType.ContentList.toString()
                    },                    
                    {
                        id: PermissionType.TenantSettings.toString(),
                        title: 'General-Configuration',
                        translate: 'NAV.COMPLAINTS.COMPLAINT_SETTINGS',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_GENERAL_CONFIGURATION,
                        permission: PermissionType.TenantSettings.toString()
                    },
                    {
                        id: PermissionType.ComplaintClassificationList.toString(),
                        title: 'Classification',
                        translate: 'NAV.COMPLAINTS.CLASSIFICATION',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_CLASSIFICATION,
                        permission: PermissionType.ComplaintClassificationList.toString()
                    },
                    {
                        id: PermissionType.AlertCriticalityList.toString(),
                        title: 'Criticality',
                        translate: 'NAV.COMPLAINTS.CRITICALITY',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_CRITICALITY_ALL,
                        permission: PermissionType.AlertCriticalityList.toString()
                    },
                    {
                        id: PermissionType.RejectedReasonList.toString(),
                        title: 'RejectedReason',
                        translate: 'NAV.COMPLAINTS.REJECTEDREASON',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_REJECTED_REASON_ALL,
                        permission: PermissionType.RejectedReasonList.toString()
                    },
                    {
                        id: PermissionType.FormSubTypeList.toString(),
                        title: 'TypeComplaints',
                        translate: 'NAV.COMPLAINTS.TYPECOMPLAINTS',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.TYPE_COMPLAINTS_ALL,
                        permission: PermissionType.FormSubTypeList.toString()
                    },
                    {
                        id: PermissionType.AlertDueDateList.toString(),
                        title: 'AlertDueDate',
                        translate: 'NAV.COMPLAINTS.ALERTDUEDATE',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_ALERT_DUE_DATE_ALL,
                        permission: PermissionType.AlertDueDateList.toString()
                    },
                    {
                        id: PermissionType.AuditList.toString(),
                        title: 'ComplaintsAudit',
                        translate: 'NAV.COMPLAINTS.AUDIT',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_AUDIT_ALL,
                        permission: PermissionType.AuditList.toString()
                    },
                    {
                        id: PermissionType.AuditList.toString(),
                        title: 'FormsManagement',
                        translate: 'NAV.COMPLAINTS.ASKQUESTION',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_ASK_QUESTION_QUESTION,
                        permission: PermissionType.AuditList.toString()
                    },
                    {
                        id: PermissionType.AuditList.toString(),
                        title: 'FormsManagement',
                        translate: 'NAV.COMPLAINTS.FORMCLASSIFICATION',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.COMPLAINTS_ASK_QUESTION_CLASSIFICATION,
                        permission: PermissionType.AuditList.toString()
                    } 
                ]
            },  
            {                
                id: 'alertModule',
                title: 'AlertsModule',
                translate: 'NAV.WF.ALERTSMODULE',
                icon: 'description',
                type: 'collapsable',
                children: [
                    {
                        id: 'AutomaticAlerts_Id',
                        title: 'AutomaticAlerts',
                        translate: 'NAV.WF.AUTOALERTS',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.WF_MANAGEMENT_AUTOALERTS,
                    },
                    {
                        id: 'ManualAlerts_Id',
                        title: 'ManualAlerts',
                        translate: 'NAV.WF.MANUALALERTS',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.WF_MANAGEMENT_MANUALALERTS,
                    },
                    {
                        id: 'AuditsAlerts_Id',
                        title: 'AuditsAlerts_title',
                        translate: 'NAV.WF.AUDITS',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.WF_MANAGEMENT_AUDIT_ALERTS,
                        permission: PermissionType.AuditList.toString()
                    }
                ]
            }, 
            {                
                id: 'casesModule',
                title: 'CasesModule',
                translate: 'NAV.WF.CASESSMODULE',
                icon: 'description',
                type: 'collapsable',
                children: [
                    {
                        id: 'AutomaticCases_Id',
                        title: 'AutomaticCases',
                        translate: 'NAV.WF.AUTOCASES',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.WF_MANAGEMENT_AUTOCASES,
                    },
                    {
                        id: 'ManualCases_Id',
                        title: 'ManualCases',
                        translate: 'NAV.WF.MANUALCASES',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: AppRoutePaths.WF_MANAGEMENT_MANUALCASES,
                    },
                    {
                        id: 'followup_actions_id',
                        title: 'followup_actions_title',
                        translate: 'NAV.FOLLOWUP_ACTIONS',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.FOLLOWUP_ACTIONS_ALL,
                        permission: PermissionType.FollowUpActionsList.toString()
                    },
                    {
                        id: 'AuditsCases_Id',
                        title: 'AuditsCases_title',
                        translate: 'NAV.WF.AUDITS',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.WF_MANAGEMENT_AUDIT_CASES,
                        permission: PermissionType.AuditList.toString()
                    }
                ]
            },                     
            {
                id: 'labels_id',
                title: 'labels_title',
                translate: 'NAV.LABELS',
                type: 'item',
                icon: 'public',
                url: AppRoutePaths.LABELS_ALL,
                permission: PermissionType.LabelList.toString()
            },
            {
                id: 'custom_labels_id',
                title: 'custom_labels_title',
                translate: 'NAV.CUSTOM-LABELS',
                type: 'item',
                icon: 'label',
                url: AppRoutePaths.CUSTOM_LABELS_ALL,
                permission: PermissionType.LabelCustomizationList.toString()
            }
        ]
    },
    {
        id: 'flat_reports',
        title: 'Flat Reports',
        translate: 'NAV.FLAT_REPORTS.TITLE',
        icon: 'description',
        type: 'collapsable',
        children: [
            {
                id: 'complaints_report',
                title: 'complaints_report_title',
                translate: 'NAV.COMPLAINT_REPORT',
                type: 'item',
                icon: 'flag',
                url: AppRoutePaths.COMPLAINT_REPORT,
                permission: PermissionType.FlatComplaintReportDetail.toString()
            },
            {
                id: 'alerts_report',
                title: 'alerts_report_title',
                translate: 'NAV.ALERT_REPORT',
                type: 'item',
                icon: 'warning_amber',
                url: AppRoutePaths.ALERT_REPORT,
                permission: PermissionType.FlatAlertReportDetail.toString()//, PermissionType.FlatReportDetail.toString()
            },
            {
                id: 'cases_report',
                title: 'cases_report_title',
                translate: 'NAV.CASES_REPORT',
                type: 'item',
                icon: 'assignment_ind',
                url: AppRoutePaths.CASES_REPORT,
                permission: PermissionType.FlatCaseReportDetail.toString()//, PermissionType.FlatReportDetail.toString()
            },
            {
                id: 'proceeding_report',
                title: 'proceeding_report_title',
                translate: 'NAV.PROCEEDINGS',
                type: 'item',
                icon: 'assignment_ind',
                url: AppRoutePaths.PROCEEDINGS_REPORT,
                permission: PermissionType.RequestFlatFilesReport.toString()//, PermissionType.FlatReportDetail.toString()
            },
        ]
    },
    {
        id: 'politics_protocols',
        title: 'Politics & Protocols',
        translate: 'NAV.POLITICS_AND_PROCEDURES',
        icon: 'description',
        type: 'collapsable',
        children: [
            {
                id: 'pp_file_directory',
                title: 'pp_file_directory_title',
                translate: 'NAV.PP_FILE_DIRECTORY',
                type: 'item',
                icon: 'assignment_ind',
                url: AppRoutePaths.PP_FILE_DIRECTORY,
                permission: PermissionType.PPList.toString()
            },
            {
                id: 'pp_visualization',
                title: 'pp_visualization_title',
                translate: 'PP.VISUALIZATION_TITLE',
                type: 'item',
                icon: 'warning_amber',
                url: AppRoutePaths.PP_VISUALIZATION,
                permission: PermissionType.PPVisualizarionList.toString()
            },
            {
                id: 'pp_approver',
                title: 'pp_pp_approver_title',
                translate: 'PP.APPROVER_TITLE',
                type: 'item',
                icon: 'warning_amber',
                url: AppRoutePaths.PP_APPROVER,
                permission: PermissionType.PPApproverList.toString()
            }
        ]
    },
    {
        id: 'risk_matrix_id',
        title: 'risk_matrix_title',
        translate:'NAV.RISK_MATRIX',
        type: 'item',
        icon: 'flag',
        url: AppRoutePaths.RISK_MATRIX,
        permission: PermissionType.SeeMockupRisk.toString()
    },
    {
        id: 'complaints_id',
        title: 'complaints_title',
        translate: 'NAV.COMPLAINTS',
        type: 'item',
        icon: 'flag',
        url: AppRoutePaths.COMPLAINT_ALL,
        permission: PermissionType.ComplaintList.toString()
    },
    {
        id: 'alerts_id',
        title: 'alerts_title',
        translate: 'NAV.ALERTS',
        type: 'item',
        icon: 'warning_amber',
        url: AppRoutePaths.ALERT_ALL,
        permission: PermissionType.AlertList.toString()
    },
    {
        id: 'cases_id',
        title: 'cases_title',
        translate: 'NAV.CASES',
        type: 'item',
        icon: 'assignment_ind',
        url: AppRoutePaths.CASES_ALL,
        permission: PermissionType.CasesList.toString()
    },   
    {
        id: 'boards-administration_id',
        title: 'boards-administration_title',
        translate: 'NAV.BOARDSADMINISTRATION',
        type: 'item',
        icon: 'assignment_ind',
        url: AppRoutePaths.BOARD_ADMINISTRATION,
        permission: PermissionType.BoardAdministrationList.toString()
    },
    {
        id: 'boards_id',
        title: 'boards_title',
        translate: 'NAV.BOARDS',
        type: 'collapsable', 
        icon: 'assignment_ind',
        children: JSON.parse(MVLocalStorageService.getItem(SessionItems.boards_nav)) 
    },
    {
        id: 'control',
        title: 'control_title',
        translate: 'NAV.CONTROL',
        icon: 'assignment_ind',
        type: 'collapsable',
        children: [
            {
                id: 'search_control',
                title: 'search_control_title',
                translate: 'NAV.SEARCH_CONTROL',
                type: 'item',
                icon: 'assignment_ind',
                url: AppRoutePaths.CONTROL_ALL,
                permission: PermissionType.ControlList.toString()
            },
            {
                id: 'control',
                title: 'control_title',
                translate: 'NAV.EXECUTIONS',
                icon: 'assignment_ind',
                type: 'collapsable',
                children: [
                    {
                        id: 'parameterization',
                        title: 'control_parameterization_title',
                        translate: 'NAV.CONTROL_PARAMETERIZATION_TEXTS',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.CONTROL_PARAMETERIZATION_ALL,
                        permission: PermissionType.ParameterizationList.toString()
                    },                    
                    {
                        id: 'parameterization-rules',
                        title: 'control_parameterization_rules_title',
                        translate: 'NAV.CONTROL_PARAMETERIZATION_RULES',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.CONTROL_PARAMETERIZATION_RULES_ALL,
                        permission: PermissionType.ParameterizationRulesList.toString()
                    },
                    {
                        id: 'parameterization-oposicion',
                        title: 'control_parameterization_oposicion_title',
                        translate: 'NAV.CONTROL_PARAMETERIZATION_OPOSICION',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.CONTROL_PARAMETERIZATION_OPOSICION_ALL,
                        permission: PermissionType.ParameterizationOposicionList.toString()
                    },
                    {
                        id: 'parameterization-manual',
                        title: 'control_parameterization_manual_title',
                        translate: 'NAV.CONTROL_PARAMETERIZATION_MANUAL',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: AppRoutePaths.CONTROL_PARAMETERIZATION_MANUAL_ALL,
                        permission: PermissionType.ParameterizationManualList.toString()
                    },

                ]
            },
            {
                id: 'control-resume',
                title: 'control_resume_title',
                translate: 'NAV.CONTROL_RESUME',
                type: 'item',
                icon: 'assignment_ind',
                url: AppRoutePaths.CONTROL_RESUME_ALL,
                permission: PermissionType.ControlResumeList.toString()
            }
        ]
    }
];
